<template>
  <div class="relative z-40" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background backdrop, show/hide based on slide-over state. -->
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-200 pointer-events-none opacity-0" :class="show && 'pointer-events-auto !opacity-100'"></div>


    <div class="fixed inset-0 w-full h-full left-0 top-0 z-20 bg-gray-500 bg-opacity-75 transition-opacity duration-200 pointer-events-none opacity-0" :class="show && 'pointer-events-auto !opacity-100'" @click="$emit('close')"></div>
    <div class="fixed inset-0 overflow-hidden pointer-events-none z-30">
      <div class="absolute inset-0 overflow-hidden ">
        <div class="pointer-events-none fixed inset-y-0 left-0 flex pr-10 sm:pr-16">

          <transition
            enter-class="-translate-x-full"
            leave-class="translate-x-0"
            enter-to-class="translate-x-0"
            leave-to-class="-translate-x-full"
          >
            <div v-if="show" class="duration-200 pointer-events-auto w-screen max-w-3xl relative z-30">
              <div class="flex h-full flex-col overflow-y-auto bg-white shadow-xl">
                <div class="p-6 px-8 shrink-0">
                  <h1 class="text-3xl font-bold tracking-tight text-gray-900">Settings</h1>
                </div>

                <SettingsNavbar v-model="selectedTab"/>

                <div class="grow flex flex-col">
                  <transition name="fade" mode="out-in">
                    <component :is="currentComponent" :key="currentComponent" @close="$emit('close')"/>
                  </transition>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>


    </div>
  </div>
</template>

<script>

import SettingsNavbar from "./SettingsNavbar"

import Smtp from "@/components/SideEditor/WebsiteContentSettings/Smtp"
import ArrivesTodayShipping from "@/components/SideEditor/WebsiteContentSettings/ArrivesTodayShipping"
import Analytics from "./Analytics/Analytics"
import ShippingCostPerCountry from "./ShippingCostPerCountry/ShippingCostPerCountry"

export default {
  components: {
    Analytics,
    ShippingCostPerCountry,
    Smtp,
    SettingsNavbar,
    ArrivesTodayShipping,
  },
  props: ['show'],
  data() {
    return {
      selectedTab: 'smtp',
    }
  },
  computed: {
    currentComponent() {
      return {
        'smtp': "Smtp",
        'analytics': "Analytics",
        'tax/country': "ShippingCostPerCountry",
        'arrives today': "ArrivesTodayShipping",
      }[this.selectedTab]
    }
  },
}

</script>
